import { PRICING, PRICING_URL } from "@/lib/marketing";
import { IncludedBadge } from "@/components/marketing/IncludedBadge";

const Line = ({ parts, testid }) => (
  <p data-testid={testid} className="text-[#121A14] leading-relaxed"><strong className="font-semibold">{parts[0]}</strong>{parts[1]}</p>
);

export const PricingBlock = () => (
  <section id="pricing" className="bg-white border-t border-[#DCE3DD]">
    <div className="max-w-7xl mx-auto px-6 py-20">
      <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#275C3F]">Pricing</span>
      <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight mt-3">Where EnviSafe fits</h2>
      <div className="mt-5"><IncludedBadge /></div>
      <div className="mt-10 grid lg:grid-cols-3 gap-6" data-testid="universal-pricing">
        <div className="lg:col-span-2 border border-[#DCE3DD] rounded-sm p-6 bg-[#F8FAF8] space-y-3">
          <p className="text-sm text-[#4B5950]">{PRICING.subsIntro}</p>
          <ul className="space-y-3">
            {PRICING.subs.map((s) => (
              <li key={s[0]} className={`pl-4 border-l-2 ${s[0].startsWith("Pro") || s[0].startsWith("Vision") ? "border-[#275C3F]" : "border-[#DCE3DD]"}`}>
                <Line parts={s} testid={`pricing-${s[0].split(" ")[0].replace(":", "").toLowerCase()}`} />
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-6">
          <div className="border border-[#DCE3DD] rounded-sm p-6"><Line parts={PRICING.compliance} testid="pricing-compliance" /></div>
          <div className="border border-[#DCE3DD] rounded-sm p-6"><Line parts={PRICING.consulting} testid="pricing-consulting" /></div>
        </div>
      </div>
      <a href={PRICING_URL} data-testid="pricing-full-link" className="inline-block mt-6 text-sm font-medium text-[#2E7599] hover:underline">See full pricing on worksafeagent.com</a>
    </div>
  </section>
);
